<template>
  <div class="wrap">
    <div class="banner">{{t("FAQ.title")}}</div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>
<style scoped lang="less">
.banner {
  width: 100%;
  height: 30rem;
  background: url('@/assets/banner.png') no-repeat center / cover;
  font-size: 7.2rem;
  padding: 10rem 0;
}
</style>
